import { Component, OnInit, Input, Output, EventEmitter, ElementRef, Inject, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { PageContentService, SessionStorageService, ParameterConfigService, ParamService, TenantService } from '../../core/index.service';
import { PageContent, Juris, Tenant, CodedLookup, ParamInfo, CSPReport, UserState } from '../../core/index.model';
import { UserRole, ParamId, RegStatus } from '../../core/enumtype'
import { LoginComponent } from '../login/login.component';
import { ProfileInfoComponent } from '../login/profileinfo.component';
import { UserInfoComponent } from '../login/userinfo.component';
import { ConfigService } from '../../core/index.service';
import { AuthenticationComponent } from '../common/index';

import { JurismgmtService } from '../../core/index.service';

import { saveAs } from 'file-saver';
import { AlertComponent } from '../common/alert.component';
import { CSPReportService } from '../../core/cspreport.service';
import { TxtAttach } from '../../core/index.model';
import { Store } from '@ngrx/store';
import { AppState } from '../../statemanagement/app.state';
import { ignoreElements } from 'rxjs/operator/ignoreElements';

@Component({
    selector: 'shared-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

    userState: UserState;
    tenant: Tenant;
    pawnMenu: boolean;
    @Output() cmdLangClick: EventEmitter<string> = new EventEmitter<string>();
    @Output() cmdMenu: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() cmdJuris: EventEmitter<Juris> = new EventEmitter<Juris>();

    //@Input() tenant: Tenant;
    @Input() pageContent: PageContent;
    @Input() scrollYP: number;
    @Input() hideStaticTitle: boolean = true;

    showNavMenu: boolean;
    currentPage: string;
    showLangOptions: boolean;
    showLoading: boolean;
    isLoading: boolean;
    message: string;
    isError: boolean;
    isAlert: boolean;
    isWarning: boolean;


    langList: CodedLookup[] = [];
    selectedLang: string;

    cspreportList: CSPReport[];
    txtattach: TxtAttach;
    hideAgency: boolean = true;
    agencyName: string = 'Agencies';
    selectedAgency: string = '';
    paramInfo: any=[];
    snLoginSkip: any;
    blnHidedropdown: boolean=true;
    @ViewChild('mapheadertext') elementHeader: ElementRef;
    headerTitle : any = 'Citizen Services Program Website';

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private elRef: ElementRef,
        public dialog: MatDialog,
        private paramConfigService: ParameterConfigService,
        private paramService: ParamService,
        private pageContentService: PageContentService,
        private storageService: SessionStorageService,
        private configService: ConfigService,
        private jurisService: JurismgmtService,
        private cspreportService: CSPReportService,
        private tenantService: TenantService,
        private store: Store<AppState>
    ) {
       this.router.events
            .filter((event) => event instanceof NavigationEnd)
            .subscribe((event) => {
                if (event instanceof NavigationEnd) {
                    this.currentPage = event.urlAfterRedirects;
                }
            }); 
            this.blnHidedropdown=true;
    }

    ngOnInit() {
        this.showLangOptions = false;
        this.hideAgency = true;
        this.pawnMenu = this.storageService.getPawn();
        console.log(this.hideStaticTitle);
        
        // this.GetCSPReportsList(this.storageService.getJurisNo())
    }

    DownloadUserDocument(fileName) {
        this.jurisService.DownloadAdminDocument(fileName)
            .subscribe(success => {
                saveAs(success, fileName + ".pdf");
            },
                err => {
                    alert("Server error while downloading file.");
                });
    }

    SetCrimeMapHeaderFontSize() {
        let font_size = '0px';

        let span: HTMLElement = (<HTMLElement>document.getElementById('mapheadertext'));

        let textLength = this.elementHeader.nativeElement.innerText.length;

        if (textLength > 58 && textLength <= 70) {
            font_size = '15px';
        }
        else if (textLength > 70 && textLength <= 80) {
            font_size = '13px';
        }
        else if (textLength > 80 && textLength <= 90) {
            font_size = '12px';
        }
        else if (textLength > 91) {
            font_size = '10px';
        }
        else {
            font_size = '22px';
        }
        return font_size;
    }

    onClickOutsideLanguageDropDown(evt: Event) {
        this.showLangOptions = false;
    }

    cmdSelectLang(strLang: string) {
        if (strLang) {
            this.cmdLangClick.emit(strLang);
        }
        this.showLangOptions = !this.showLangOptions;
    }

    // Modified by Punithavathy for CRM# 81021 on 9/7/18 to enable language configuration based on the system Parameter
    cmdShowLang(langList: CodedLookup[]) {
        let defaultLang = langList && langList.length > 0 ? langList[0].CodeValue : null;
        let langType = langList && langList.length > 0 ? langList.map(x => x.CodeValue) : null;

        if ((!this.storageService.getLang() && defaultLang) || (langType && !(langType.indexOf(this.storageService.getLang()) !== -1)))
            this.storageService.setLanguage(defaultLang);

        let selectedLang = langList && langList.length > 0 ? langList.find(x => x.CodeValue == this.storageService.getLang()) : null;

        if (selectedLang)
            this.selectedLang = selectedLang.Description;
        return selectedLang ? selectedLang.Description : null;
    }

    showJurisList1(): boolean {
        if ((this.storageService.getUserRole() === UserRole.Anonymous || this.storageService.getUserRole() == UserRole.Citizen || this.storageService.getUserRole() === UserRole.Admin || this.storageService.getUserRole() === UserRole.SuperAdmin || this.storageService.getUserRole() === UserRole.Juris) && (this.storageService.getTenantState().Juris.length === 1)) {
            return false;
        }
        else if (this.storageService.getUserRole() == UserRole.Citizen || this.storageService.getUserRole() === UserRole.Admin || this.storageService.getUserRole() === UserRole.SuperAdmin || this.storageService.getUserRole() === UserRole.Juris) {
            this.selectedAgency = this.storageService.getJurisName();
            this.hideAgency = false;
            return true;
        }
        else if (this.storageService.getUserRole() == UserRole.Anonymous) {
            this.selectedAgency = this.storageService.getJurisName();
            this.agencyName = 'Agencies';
            this.hideAgency = true;
            return true;
        }
        else {
            this.agencyName = 'Agencies';
            this.hideAgency = true;
            return true;
        }
    }

    cmdRedirect(strPage: string) {

        this.pageContentService.pageContentYN = true;

        if (this.currentPage == ("/" + strPage)) {
            this.pageContentService.pageContentYN = false;
        }

        let link = [strPage];
        this.router.navigate(link)
            .then(success => {
                if (success) {
                    this.pageContentService.pageContentYN = false;
                }
                else {
                    this.pageContentService.pageContentYN = false;

                    if (this.currentPage != ("/" + strPage)) {
                        this.dialog.closeAll();

                        this.dialog.open(AuthenticationComponent, {
                            disableClose: true,
                            panelClass: "alert-modal",
                            data: {
                                message: strPage === 'services/location' ? 'House_Check' : 'The service is accessible to authenticated users only.',
                                RouterLink: strPage
                            }
                        });
                    }
                }
            })
            .catch(err => {
                this.pageContentService.pageContentYN = false;
            });
    }

    cmdRedirectJOB(strPage: string, filename: string, FormType: string, ScreenName: string) {
   
this.getParamInfo();
if(this.snLoginSkip=="1" && FormType=="SN"){
    localStorage.setItem("SNForms",FormType);
    localStorage.setItem("AllowSNForms","SN")
}
else{
    localStorage.setItem("SNForms",null);
}
if(localStorage.getItem("SNForms") == "OP"){
    localStorage.removeItem("SNForms");
}
        var names = "services/pdfformsview";
        let CitizenUserID = this.storageService.getUserID();
        this.storageService.setPDFUrl(names + '/' + filename + '/' + FormType + '/' + ScreenName);
        this.storageService.SetRequestFormUrl('services/servicejobapp/' + filename + '/' + FormType + '/' + ScreenName);
        this.pageContentService.pageContentYN = true;

        if (this.currentPage == ("/" + strPage)) {
            this.pageContentService.pageContentYN = false;
        }

        let link = [strPage];
        let filename1 = [filename];
        this.router.navigate([link, filename])
        this.router.navigate(link)
            .then(success => {
                if (success) {
                    this.pageContentService.pageContentYN = false;
                    localStorage.removeItem("AllowSNForms");
                }
                else {
                    this.pageContentService.pageContentYN = false;

                    if (this.currentPage != ("/" + strPage)) {
                        this.dialog.closeAll();
                        if( localStorage.getItem("SNForms") =="SN"){
                           
                            this.blnHidedropdown=false;
                            setTimeout(()=>{
                                this.blnHidedropdown=true;
                            },100);
                            localStorage.removeItem("SNForms");
                        }
                        else{
                            if (CitizenUserID == null || this.isAdminUser() || this.isSuperAdminUser()) {
                                this.dialog.open(AuthenticationComponent, {
                                    disableClose: true,
                                    panelClass: "alert-modal",
                                    data: { message: strPage === 'Forms/PDFForm' ? 'PDFForm' : 'The service is accessible to authenticated users only.' }
                                });
                            }
                            this.blnHidedropdown=false;
                            setTimeout(()=>{
                                this.blnHidedropdown=true;
                            },100);
                        }
                      
                       
                        
                    }
                }
            })
            .catch(err => {
                this.pageContentService.pageContentYN = false;
            });
    }

    cmdLanguageClick(strLang: string) {
        this.cmdLangClick.emit(strLang);
    }

    cmdMenuClick() {
        this.cmdMenu.emit(true);
    }

    cmdJurisClick(juris: Juris) {
        this.cmdJuris.emit(juris);

        let dialogRef = this.dialog.open(AlertComponent, {
            disableClose: true,
            panelClass: 'alert-modal',
            data: { message: this.pageContentService.getTxtJurisName('Home_AgencyConfirmContent', this.storageService.getLang(), juris.JurisName), showCancelBtn: true }
        });

        dialogRef.afterClosed().subscribe(cmd => {
            if (cmd) {
                if (cmd == 'Ok') {
                    this.isLoading = true;
                    this.showLoading = false;
                    window.localStorage.setItem('SelectedAgencyInfo', JSON.stringify(juris));
                } else {
                    this.showLoading = false;
                    this.dialog.closeAll();
                }
            }
            let hostedJuris: any;
            this.tenantService.getTenant(this.storageService.getTenantState().TenantURL).then(tenant_response => {
                if (tenant_response && tenant_response.Juris.length > 0) {
                    this.tenant = tenant_response as Tenant;
                    hostedJuris = this.tenant.Juris.find(item => item.JurisName === this.storageService.getUserState().JurisName)
                    this.userState = hostedJuris;
                    this.storageService.setUserState(this.userState, true);
                    window.location.reload();
                }
            });
        });
    }

    // Open Login

    openLoginModal() {
        let dialogRef;
        if (this.storageService.getUserRole() === UserRole.Citizen) {
            dialogRef = this.dialog.open(ProfileInfoComponent, {
                disableClose: false,
                panelClass: 'profile-info-modal'
            });
        }
        else if (this.storageService.getUserRole() === UserRole.Admin || this.storageService.getUserRole() === UserRole.SuperAdmin || this.storageService.getUserRole() === UserRole.Juris) {
            dialogRef = this.dialog.open(UserInfoComponent, {
                disableClose: false,
                panelClass: 'profile-info-modal'
            });
        }
        else {
            dialogRef = this.dialog.open(LoginComponent, {
                disableClose: false,
                panelClass: 'login-modal',
                autoFocus: false
            });
        }

        dialogRef.afterClosed().subscribe(() => {
        });
    }


    public isAdminUser(): boolean {
        if (this.storageService.getUserRole() == UserRole.Admin || this.storageService.getUserRole() == UserRole.SuperAdmin || this.storageService.getUserRole() === UserRole.Juris) {
            return true;
        }
        else {
            return false;
        }
    }

    public isSuperAdminUser(): boolean {
        if (this.storageService.getUserRole() == UserRole.SuperAdmin)
            return true;
        else
            return false;
    }

    public isCitizen(): boolean {
        if (this.storageService.getUserRole() == UserRole.Citizen) {
            return true;
        }
        else {
            return false;
        }
    }

    public getPawn(): boolean {
        if (this.storageService.getPawn() == true) {
            return true;
        }
        else {
            return false;
        }
    }
    //public getRegStatus(): boolean {        
    //    if (this.storageService.getRegStatus() == RegStatus.AuthorizedUser || this.storageService.getRegStatus() == RegStatus.RegisterUser) {
    //        return true;
    //    }
    //    else {
    //        return false;
    //    }
    //}
    enableServiceLink(): boolean {
        return this.paramConfigService.enableLink();
    }

    GetLanguageParamValue() {
        let tempLangList: CodedLookup[] = [];
        let paramInfo: ParamInfo;
        let paramValue: any;

        paramInfo = this.paramConfigService.GetSystemParamInfo(ParamId.Languages);
        paramValue = this.paramConfigService.GetSystemParamValue(ParamId.Languages);

        if (paramInfo) {
            var langList = paramValue ? paramValue.split(',') : null;
            if (langList) {
                for (var i = 0; i < langList.length; i++) {
                    var language = paramInfo.CodedLookup ? paramInfo.CodedLookup.find(x => x.CodeValue == langList[i]) : null;
                    tempLangList.push(language);
                }
            }

            this.langList = tempLangList.length > 0 ? tempLangList : paramInfo.CodedLookup ? paramInfo.CodedLookup : null;
        }

        return this.cmdShowLang(this.langList);
    }

    GetCSPReportsList(JurisId: number) {
        this.cspreportService.GetCSPReportsList(JurisId).then(
            (response) => {
                this.cspreportList = response;
            },
            (err) => {
                console.log("On Load Error CSP Report: " + err);
            });
        console.log("JurisId: " + JurisId);
    }

    OpenReportsWindow(CSPReportID: string) {
        this.router.navigateByUrl('services/reportspdfview/' + CSPReportID);


    }
    //cmdRedirectPermitWindow(screenName: string) {
    //    let screen = screenName.split(' ').join('_');
    //    this.router.navigateByUrl('citpermit/permit/' + screen);
    //    console.log(screen);


    //}
    cmdRedirectPermitWindow(screenName: string) {        
        this.pageContentService.pageContentYN = true;
        let screen = screenName.split(' ').join('_');
        let strPage = 'citpermit/permit/' + screen;
        if (this.currentPage == ("/" + strPage )) {
            this.pageContentService.pageContentYN = false;
        }
      
        let link = [strPage];
        console.log(link);
        this.router.navigate(link)
            .then(success => {
                if (success) {
                    this.pageContentService.pageContentYN = false;
                }
                else {
                    this.pageContentService.pageContentYN = false;

                    if (this.currentPage != ("/" + strPage )) {
                        this.dialog.closeAll();

                        this.dialog.open(AuthenticationComponent, {
                            disableClose: true,
                            panelClass: "alert-modal",
                            data: {
                                message: strPage === 'services/location' ? 'House_Check' : 'The service is accessible to authenticated users only.',
                                RouterLink: strPage
                            }
                        });
                    }
                }
            })
            .catch(err => {
                this.pageContentService.pageContentYN = false;
            });
    }

    // Show Alert

    showAlert(strMsg: string, isErr: boolean, showWarning: boolean = false) {
        this.isAlert = true;
        this.isError = isErr;
        this.isWarning = showWarning;
        this.message = strMsg;
    }

    // Close Alert

    closeAlert() {
        this.isAlert = false;
    }
    getParamInfo() {  

        this.store.select("parameter").subscribe(paramObject => {
            if (paramObject) {
                this.paramInfo = paramObject[0];
                for(let x of this.paramInfo){
                    if(x.ParamID==5625 ){
                
                        this.snLoginSkip=x.DefaultValue;
                }
            }
               
            }
        });
    }

}




// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/layout/header.component.ts